import request from '../../../../shared/lib/request';
import { RPC } from '../../../../shared/constants';

const getDocuments = (impresaId) =>
  request({
    url: `${RPC.PROCESSO_IMPRESA_DOCUMENTS}/${impresaId}`,
    method: 'GET',
  });

const setSbloccoGenerazioneContratto = (id) =>
  request({
    url: RPC.GESTIONE_PRROCESSO_IMPRESE,
    method: 'POST',
    data: {
      params: {
        pratica: id,
      },
      method: 'conferma_sblocco_generazione_contratto',
    },
  });

const annullaSbloccoGenerazioneContratto = (id) =>
  request({
    url: RPC.GESTIONE_PRROCESSO_IMPRESE,
    method: 'POST',
    data: {
      params: {
        pratica: id,
      },
      method: 'annulla_sblocco_generazione_contratto',
    },
  });

const confermaSenior = (id, esito, nota) =>
  request({
    url: RPC.GESTIONE_PRROCESSO_IMPRESE,
    method: 'POST',
    data: {
      params: {
        pratica: id,
        esito,
        nota: nota || null,
      },
      method: 'conferma_controllo_senior_manager',
    },
  });

const annullaConfermaSenior = (id) =>
  request({
    url: RPC.GESTIONE_PRROCESSO_IMPRESE,
    method: 'POST',
    data: {
      params: {
        pratica: id,
      },
      method: 'annulla_conferma_controllo_senior_manager',
    },
  });

const blocca = (motivazione, impreseId, nota) =>
  request({
    url: RPC.GESTIONE_PRROCESSO_IMPRESE,
    method: 'POST',
    data: {
      params: {
        impresaId: impreseId,
        motivazione,
        nota,
      },
      method: 'set_chiusa_negativa',
    },
  });

const aggiungiGarante = (impresaId, anagraficaId) =>
  request({
    url: RPC.GESTIONE_PRROCESSO_IMPRESE,
    method: 'POST',
    data: {
      params: {
        impresaId: impresaId,
        anagraficaId,
      },
      method: 'aggiungi_garante',
    },
  });

const rimuoviGarante = (impresaId) =>
  request({
    url: RPC.GESTIONE_PRROCESSO_IMPRESE,
    method: 'POST',
    data: {
      params: {
        impresaId: impresaId,
      },
      method: 'rimuovi_garante',
    },
  });

const GestioneProcessoImprese = {
  getDocuments,
  setSbloccoGenerazioneContratto,
  annullaSbloccoGenerazioneContratto,
  confermaSenior,
  annullaConfermaSenior,
  blocca,
  aggiungiGarante,
  rimuoviGarante
};

export default GestioneProcessoImprese;



// WEBPACK FOOTER //
// ./app/shared/services/rpc/gestione-processo-imprese/index.js